import { useMergedConfigStore } from 'src/stores/merged_config.js'

import {
  applyLayoutVariables,
  LAYOUT_KEYS,
} from 'src/services/layout_vars/layout_vars.js'

const ACTIONS = new Set([
  'setPreference',
  'unsetPreference',
  'set',
  'unset',
  'setTemporarily',
  'unsetTemporarily',
])

const WATCHED_PATHS = new Set([
  ...LAYOUT_KEYS,
  ...LAYOUT_KEYS.map((x) => 'simple.' + x),
])

// A layout setting changed: update its custom property.
export const piniaStylePlugin = ({ store }) => {
  if (store.$id === 'sync_config' || store.$id === 'local_config') {
    store.$onAction(({ name, args, after }) => {
      if (ACTIONS.has(name) && WATCHED_PATHS.has(args[0]?.path)) {
        after(() => applyLayoutVariables(useMergedConfigStore().mergedConfig))
      }
    })
  }
}
